import PaymentRequestsFilters from './index.vue'
export default PaymentRequestsFilters